import { Modal } from "./Modal";

type CheckInStep =
  | "confirm-membership"
  | "confirm-withdraw"
  | "withdraw-complete";

interface CheckInModalProps {
  error?: unknown;
  isPending?: boolean;
  onClose: () => void;
  onConfirmContinue: () => void;
  onConfirmWithdraw: () => void;
  onStartWithdraw: () => void;
  onReviewProfile: () => void;
  open: boolean;
  step: CheckInStep;
}

export function CheckInModal({
  error,
  isPending = false,
  onClose,
  onConfirmContinue,
  onConfirmWithdraw,
  onReviewProfile,
  onStartWithdraw,
  open,
  step,
}: CheckInModalProps) {
  return (
    <Modal onClose={onClose} open={open}>
      <div aria-modal="true" className="modal" role="dialog">
        <div className="modal-title title-md">Panel membership check-in</div>

        {step === "confirm-membership" ? (
          <>
            <div className="modal-body-text">
              Your regular panel check-in is due. Are you still happy to be part
              of the panel?
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-outline btn-full"
                disabled={isPending}
                onClick={onStartWithdraw}
                type="button"
              >
                No, leave the panel
              </button>
              <button
                className="btn btn-full"
                disabled={isPending}
                onClick={onConfirmContinue}
                type="button"
              >
                {isPending ? "Saving..." : "Yes, continue"}
              </button>
            </div>
            <div className="modal-body-text" style={{ marginTop: 12 }}>
              If you continue, we&apos;ll ask you to review your profile details
              next.
            </div>
          </>
        ) : null}

        {step === "confirm-withdraw" ? (
          <>
            <div className="modal-body-text">
              Are you sure? You will lose access to your account and will not be
              able to take part in future panel activity.
            </div>
            <div className="modal-warning">
              <strong>This starts account removal</strong>
              Please only continue if you definitely want to leave the panel.
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-outline btn-full"
                disabled={isPending}
                onClick={onClose}
                type="button"
              >
                Cancel
              </button>
              <button
                className="btn btn-full"
                disabled={isPending}
                onClick={onConfirmWithdraw}
                style={{ background: "var(--red)", color: "#fff" }}
                type="button"
              >
                {isPending ? "Saving..." : "Yes, leave the panel"}
              </button>
            </div>
          </>
        ) : null}

        {step === "withdraw-complete" ? (
          <>
            <div className="modal-body-text">
              We have received your request. Please allow 24 hours for your
              account to be deactivated and your data removed. You will receive
              an email to confirm once this is completed.
            </div>
            <div className="modal-footer">
              <button className="btn btn-full" onClick={onClose} type="button">
                Close
              </button>
            </div>
          </>
        ) : null}

        {step === "confirm-membership" && !isPending && !error ? (
          <div className="modal-footer" style={{ marginTop: 8 }}>
            <button
              className="btn btn-outline btn-full"
              onClick={onReviewProfile}
              type="button"
            >
              Review profile details now
            </button>
          </div>
        ) : null}

        {Boolean(error) ? (
          <div className="alert alert-warn" style={{ marginTop: 12 }}>
            <strong>Could not update check-in</strong>
            <span>
              {error instanceof Error
                ? error.message
                : "Please try again shortly."}
            </span>
          </div>
        ) : null}
      </div>
    </Modal>
  );
}
